import { render, staticRenderFns } from "./PreviewPoll.vue?vue&type=template&id=39cd5642&"
import script from "./PreviewPoll.vue?vue&type=script&lang=js&"
export * from "./PreviewPoll.vue?vue&type=script&lang=js&"
import style0 from "./PreviewPoll.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports